import axios from "axios";
import { format } from "date-fns";

const apiUrl = 'https://railresourcing.api.pace-is.co.uk';
const mobileApiUrl = 'https://api.pace-is.co.uk';

export const loginUser = async (payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/home/login`, payload)
        return response;
    } catch (error: any) {
        return error?.response?.data.message || 'An error occurred during login. Please try again.';
    }
}

export const getProjects = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Collaborations/GetProjects`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getClients = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Collaborations/GetClients`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getAllClients = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/options/GetClients`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const GetRegions = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetRegions`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addNewShift = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/Resourcing/AddNewJob`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const getWeeklyJobs = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWeeklyJobs?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getEditJobModal = async (token: any, id: string) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetEditJobModel?jobId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const editShift = async (token: any, payload: any) => {
    try{
        const response = await axios.post(`${apiUrl}/Resourcing/EditJob`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error){
        return error
    }
}

export const editJobGridLocation = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/EditJobGridLocation`, payload,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
}

export const getWorkersFromJob = async (token: any, id: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWorkersFromJob?jobId=${id}`,{
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const GetWorkersSuggestions = async (token: any, value: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/options/GetWorkersSuggestions?search=${value}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteJob = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Resourcing/DeleteJob?jobId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getSignedInOptions = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetSignedInOptions`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error
    }
}

export const getJobStatuses = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetJobStatuses`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error
    }
}

export const addNewWorkerToShift = async (token: any, jobId: any, orderNumber: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/AddNewWorkerToJob?jobId=${jobId}&orderNumber=${orderNumber}`, {},
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        return error
    }
}

export const updateJobWorkerRows = async (token: any, payload: any) => {
    try {
        for(let i = 0; i < payload.length; i++) {
            payload[i].id = payload[i].userJobId;
        }
        const response = await axios.post(`${apiUrl}/Resourcing/UpdateJobWorkerRows`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const removeWorkersFromJob = async (token: any, payload: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Resourcing/RemoveWorkersFromJob`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: payload 
        })
        return response
    } catch(error) {
        console.log(error)
    }
}

export const getClientsPieData = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Statistics/getClientsPieData?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getJobsStatusPieData = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Statistics/getJobsStatusPieData?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getClientJobsStatistics = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Statistics/GetClientJobsStatistics?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getJobsLocations = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/getJobsLocations?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const changeWorkerRowColorIdentifier = async (token: any, JobRowsIds: any, color: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/ChangeWorkerRowColorIdentifier`, {
            JobRowsIds: JobRowsIds,
            Color: color
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const saveJobNotes = async (token: any, jobId: any, notes: any, notesJson: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/SaveJobNotes?jobId=${jobId}&notes=${notes}&notesJson=${notesJson}`, {} ,{
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response
    } catch (error) {
        console.log(error)
    }
}

export const saveJobNotesModel = async (token: any, jobId: any, notes: any, notesJson: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/SaveJobNotesModel`, {
            jobId: jobId,
            notes: notes,
            notesJson: notesJson,
        } ,{
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response
    } catch (error) {
        console.log(error)
    }
}

export const duplicateShift = async (token: any, jobId: any, jobDate: any, rowIndex: any, colIndex: any, week: any, HubGroupName: any, doNotTakeWorkers: boolean, existingJobId?: any ) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/DuplicateJob`, {
            jobId: jobId,
            existingJobId: existingJobId,
            jobDate: jobDate,
            rowIndex: rowIndex,
            columnIndex: colIndex,
            week: week,
            HubGroupName: HubGroupName,
            doNotTakeWorkers: doNotTakeWorkers,
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })

        return response;
    } catch (error: any) {
        console.log(error.response);
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
}

export const getPaceSiteContacts = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetSiteContacts`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getClientSitescontact = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetClientSitesContacts`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getPaymentMethod = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetPaymentMethods`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getWorkRolesSuggestions = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetWorkRolesSuggestions`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getWeeklyWorkersData = async (token: any, week: number, year: number) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWeeklyWorkersData?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch(error) {
        console.log(error)
    }
}

export const getWeeklyOnCallDetails = async (token: any, week: number, year: number) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWeeklyOnCallDetails?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch(error) {
        console.log(error)
    }
}

export const getWeeklyWorkersList = async (token: any, week: number, year: number) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWeeklyWorkersList?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getWeeklyJobsDetailsForMap = async (token: any, week: any, year: number) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetWeeklyJobsDetailsForMap?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    }catch(error){
        console.log(error)
    }
}

export const getOrgChartDiagram = async (token: any, week: any, year: number) => {
    try {
        const response = await axios.get(`${apiUrl}/Statistics/GetOrgChartDiagram?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const GetJobWithWorkersModel = async (token: any, jobId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetJobWithWorkersModel?jobId=${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addNewClient = async (token: any, companyName: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Collaborations/AddNewClient?companyName=${companyName}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const addNewProject = async (token: any, projectName: any, companyId: any, postCode: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Collaborations/AddNewProject`, {
                ProjectName: projectName,
                CompanyId: companyId,
                PostCode: postCode
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const editProject = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Collaborations/EditProject`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response;
    } catch (error: any) {
        if (error.response) {
            if (error.response.status === 403) {
                return 403
            } else {
                console.log(`Error: ${error.response.status} - ${error.response.statusText}`);
            }
        } else {
            console.log("An unexpected error occurred:", error.message);
        }
        
        return error;
    }
}

export const editClient = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Collaborations/EditClient`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response;
        
    } catch (error: any) {
        if (error.response) {
            if (error.response.status === 403) {
                return 403
            } else {
                console.log(`Error: ${error.response.status} - ${error.response.statusText}`);
            }
        } else {
            console.log("An unexpected error occurred:", error.message);
        }
        
        return error;
    }
}

export const GetAllRegions =async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetRegions`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response.data
    }catch (error) {
        console.log(error)
    }
}

export const GetAllWorkRole = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetWorkRoleSuggestions`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response.data
    }catch (error) {
        console.log(error)
    }
}

export const getAllPaceSiteContacts = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetSiteContacts`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getAllClientSiteContacts = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetClientSiteContacts`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addNewRegion = async (token: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/AddNewRegion?region=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const AddNewWorkerRoleSuggestion = async (token: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/AddNewWorkRoleSuggestion?workRoleSuggestion=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const AddNewSiteContacts = async (token: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/AddNewSiteContact?siteContact=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const AddNewClientSiteContacts = async (token: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/AddNewClientSiteContact?clientSiteContact=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const editRegion = async (token: any, id: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/EditRegion?regionId=${id}&region=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editWorkRoleSuggestion = async (token: any, id: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/EditWorkRoleSuggestion?workRoleSuggestionId=${id}&workRoleSuggestion=${name}`, id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editPaceSiteContact = async (token: any, id: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/EditSiteContact?siteContactId=${id}&siteContact=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editClientSiteContact = async (token: any, id: any, name: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ResourcingData/EditClientSiteContact?clientSiteContactId=${id}&clientSiteContact=${name}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const deleteRegion = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/ResourcingData/DeleteRegion?regionId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteWorkRole = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/ResourcingData/DeleteWorkRoleSuggestion?workRoleSuggestionId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deletePaceSiteContact = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/ResourcingData/DeleteSiteContact?siteContactId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteClientSiteContact = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/ResourcingData/DeleteClientSiteContact?clientSiteContactId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getPaymentMethods = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Payroll/GetPaymentMethods`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addNewPaymentMethod = async (token: any, name: any, displayName: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Payroll/AddNewPaymentMethod?name=${name}&displayName=${displayName}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const editPaymentMethod = async (token: any, id: any, name: any, displayName: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Payroll/EditPaymentMethod?paymentMethodId=${id}&editName=${name}&displayName=${displayName}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const generatePayrollReport = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Payroll/GeneratePayrollReport?week=${week}&year=${year}`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Payroll_Report_${week}_${year}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href); 
        return response
    } catch (error) {
        console.error(error);
    }
}

export const getCompetencies = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetCompetencies`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getExperiences = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Options/GetExperienceTypes`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const generateFatigueReport = async (token: any, startDate: any, endDate: any, workerId: any, workerName: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GenerateFatigueReport`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                workerId: workerId,
                workerName: workerName
            },
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${workerName} - Fatique and Risk ${format(new Date(), 'dd-MM-yyyy')}.xls`;
        link.click();
        window.URL.revokeObjectURL(link.href); 
        return response
    } catch (error) {
        console.error(error);
    }
}

export const getAllCompetenecies = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Competencies/GetCompetencies`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addNewCompetency = async (token: any, competencyName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Competencies/AddNewCompetency?competencyName=${competencyName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const editCompetency = async (token: any, competencyId: any, competencyName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Competencies/EditCompetency?competencyId=${competencyId}&editedCompetencyName=${competencyName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllExperiences = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Experiences/GetExperienceTypes`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addNewExperience = async (token: any, experienceName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Experiences/AddNewExperienceType?experienceName=${experienceName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const editExperience = async (token: any, experienceTypeId: any, editedExperienceName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Experiences/EditExperienceType?experienceTypeId=${experienceTypeId}&editedExperienceName=${editedExperienceName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const sendPushNotifications = async (token: any, jobId: any, workers: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/Notifications/SendPushNotifications?jobId=${jobId}`, 
            workers, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    }catch(error) {
        console.log(error)
    }
}

export const getDailyWorkersList = async (token: any, day: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetDailyWorkersList?day=${day}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getWorkforceLocations = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/WorkforceMap`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getStaffDetails = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/getStaffDetails`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getClientsFromResourceGrid = async (token: any, codeName: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetClientsFromResourceGrid?codeName=${codeName}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addClientToResourceGrid = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/AddNewClientToResourceGrid`, payload, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const editClientToResourceGrid = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/EditClientFromResourceGrid`, payload, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteClientFromResourceGrid = async (token: any, payload: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Resourcing/DeleteClientFromResourceGrid`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: payload 
        })
        return response
    } catch(error) {
        console.log(error)
    }
}

export const updateGeofences = async (token: any, geofence: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/Location/UpdateGeofences`, geofence, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getGeofences = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Location/GetGeofences`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const addGeofence = async (token: any, geofence: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/Location/AddGeofence`, geofence, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const deleteGeofence = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${mobileApiUrl}/Location/DeleteGeofence?geofenceId=${id}`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateGeofence = async (token: any, geofence: any) => {
    try {
        const response = await axios.patch(`${mobileApiUrl}/Location/updateGeofence`, geofence, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getLocationLogger = async (token: any, pagination: any, search?: any) => {
    try {
        if(search) {
            const response = await axios.get(`${apiUrl}/api/Locations/LocationLogger?search=${search}&pagination=${pagination}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }}
            )
            return response.data
        }
        const response = await axios.get(`${apiUrl}/api/Locations/LocationLogger?pagination=${pagination}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }}
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addWorkerToGeofence = async (token: any, geofenceId: any, userId: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/Location/AssignUsertoGeofence?geofenceId=${geofenceId}&userId=${userId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getUsersFromGeofence = async (token: any, geofenceId: any) => {
    try {
        const response = await axios.get(`${mobileApiUrl}/Location/GetUsersFromGeofence?geofenceId=${geofenceId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const removeWorkerFromGeofence = async (token: any, geofenceId: any, userId: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/Location/RemoveUserFromGeofence?geofenceId=${geofenceId}&userId=${userId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getWebforms = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WebForms/GetWebForms`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const generateColasTimesheet = async (token: any, week: any, year: any, labourOrderNumber: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Timesheets/GenerateColasTimesheet?week=${week}&year=${year}&labourOrderNumber=${labourOrderNumber}`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Timesheet_Colas_${week}_${year}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href); 
        return response
    } catch (error) {
        console.error(error);
    }
}

export const generateColasWeekendTimesheet = async (token: any, week: any, year: any, labourOrderNumber: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Timesheets/GenerateColasWeekendTimesheet?week=${week}&year=${year}&labourOrderNumber=${labourOrderNumber}`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Timesheet_Colas_Weekend_${week}_${year}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href); 
        return response
    } catch (error) {
        console.error(error);
    }
}

export const getSignInOrOutLogs = async (token: any, pagination: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/SignInOrOut/getSignInOrOutLogs?pagination=${pagination}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }}
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const searchWorkers = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/WorkerManagement/searchWorkers`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error){
        console.log(error)
    }
}

export const fatigueCheckV2 = async (token: any, year: any, week: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/FatigueCheckV2?year=${year}&week=${week}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
        }})
        
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getAuthorizedDrivers = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/AuthorizedDrivers/GetAuthorizedDrivers`, {
            headers:{
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addAuthorizedDrivers = async (token: any, id: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/AuthorizedDrivers/AddAuthorizedDriver?userId=${id}`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const removeAuthorizedDriver = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/AuthorizedDrivers/removeAuthorizedDriver?userId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getTickets = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Tickets/getTickets`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addTicket = async (token: any, ticketName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Tickets/AddNewTicket?ticketName=${ticketName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editTicket = async (token: any, ticketId: any, newTicketName: any) => {
    try {
        const response = await axios.patch(
            `${apiUrl}/api/Tickets/EditTicket?ticketId=${ticketId}&newTicketName=${newTicketName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const getWorkerProfile = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/getWorkerProfile?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getDeletedJobsHistory = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetDeletedJobsHistory`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const deleteJobPermanently = async (token: any, deleteJobId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Resourcing/deleteJobPermanently?deletedJobId=${deleteJobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const restoreDeletedJob = async (token: any, deleteJobId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/restoreDeletedJob?deletedJobId=${deleteJobId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const deleteJobOnOverride = async (token: any, jobId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Resourcing/DeleteJobOnOverride?jobId=${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const updateProfilePhoto = async (token: any, workerId: any, image: any) => {
    try {
        const formData = new FormData();
        formData.append('image', image);

        const response = await axios.patch(`${apiUrl}/api/workerManagement/updateProfilePhoto?workerId=${workerId}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const saveJobVersionHistory = async (token: any, jobId: any, changes: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/SaveJobVersionHistory`,{
            jobId: jobId,
            changes: changes
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getJobVersionHistory = async (token: any, jobId: any ) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/GetJobVersionHistory?jobId=${jobId}`,{
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const assignCompetencyToUser = async (token: any, payload: any) => {
    try {
        const formData = new FormData();
        formData.append('userId', payload.userId);
        formData.append('competencyId', payload.competencyId);
        formData.append('expDate', payload.expDate);
        formData.append('skillStatus', payload.skillStatus);

        const response = await axios.post(`${apiUrl}/api/Competencies/AssignCompetencyToUser`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        })

        return response;
    } catch (error) {
        console.log(error)
    }
}

export const removeCompetencyFromUser = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/Competencies/RemoveCompetencyFromUser?userCompetencyId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const assignTicketToUser = async (token: any, payload: any) => {
    try {
        const formData = new FormData();
        formData.append('userId', payload.userId);
        formData.append('ticketId', payload.ticketId);
        formData.append('expDate', payload.expDate);
        formData.append('ticketStatus', payload.ticketStatus);

        if (payload.ticketDocuments && payload.ticketDocuments.length) {
            for (let i = 0; i < payload.ticketDocuments.length; i++) {
                formData.append('ticketDocuments', payload.ticketDocuments[i]);
            }
        }

        const response = await axios.post(`${apiUrl}/api/Tickets/AssignTicketToUser`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const removeTicketFromUser = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/Tickets/removeTicketFromUser?userTicketId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const assignExperienceToUser = async (token: any, userId: any, experienceTypeId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Experiences/assignExperienceToUser?userId=${userId}&experienceTypeId=${experienceTypeId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response;
    } catch (error) {
        console.log(error)
    }
}

export const removeExperienceFromUser = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/Experiences/removeExperienceFromUser?userExperienceId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const addWorkerAccount = async (token: any, payload: {}) => {
    try {
        const response = await axios.post(`${apiUrl}/api/WorkerManagement/AddWorkerAccount`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editUserTicket = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/Tickets/EditUserTicket`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const editUserCompetency = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/Competencies/editUserCompetency`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const getUserTicketDocuments = async (token: any, userTicketId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Tickets/getUserTicketDocuments?userTicketId=${userTicketId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const addTicketDocuments = async (token: any, payload: any) => {
    try {
        const formData = new FormData();
        formData.append('userTicketId', payload.userTicketId);
        if (payload.documents && payload.documents.length) {
            for (let i = 0; i < payload.documents.length; i++) {
                formData.append('documents', payload.documents[i]);
            }
        }

        const response = await axios.post(`${apiUrl}/api/Tickets/AddTicketDocuments`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const deleteTicketDocument = async (token: any, ticketDocumentId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/Tickets/DeleteTicketDocument?ticketDocumentId=${ticketDocumentId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const getUpdateWorkerModel = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/workerManagement/GetUpdateWorkerModel?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const updateWorker = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/workerManagement/updateWorkerModel`, payload, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getjobWorkersInfo = async (token: any, jobId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/getJobWorkersInfo?jobId=${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getJobPosts = async (token: any, pagination: number) => {
    try {
        const response = await axios.get(`${apiUrl}/posts/GetJobPosts?pagination=${pagination}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addJobPost = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/posts/addJobPost`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const removeJobPost = async (token: any, postId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/Posts/removeJobPost?postId=${postId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response
    } catch (error) {
        return error;
    }
}

export const getInterestedWorkers = async (token: any, postId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Posts/getInterestedWorkers?postId=${postId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getMyProfileData = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Profile/GetProfile`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const updateProfile = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/Profile/UpdateProfile`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response.status;
    } catch (error) {
        return error;
    }
}

export const changePassword = async (token: any, oldPassword: string, newPassword: string) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/Profile/ChangePassword?oldPassword=${oldPassword}&newPassword=${newPassword}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response.status;
    } catch (error) {
        return error;
    }
}

export const getUserCount = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/statistics/getUserCount`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getClientCount = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/statistics/getClientCount`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getProjectCount = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/statistics/getProjectCount`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getJobsWeeklyStatistics = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/statistics/getJobsWeeklyStatistics?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getRailCalendars = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetRailCalendars`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const addRailCalendar = async (token: any, railYearStart: any, weeks: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/ResourcingData/addRailCalendar`,
            {
                railYearStart: railYearStart,
                weeks: weeks
            }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const deleteRailCalendar = async (token: any, id: string, railYearStart: string) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/ResourcingData/DeleteRailCalendar`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: {
                id,
                railYearStart
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const editRailCalendar = async (token: any, id: any, railYearStart: any, weeks: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/ResourcingData/editRailCalendar`, {
            id: id,
            railYearStart: railYearStart,
            weeks: weeks,
        }, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getRoles = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/UserManagement/getRoles`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const addUser = async (token: any, data: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/UserManagement/addUser`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const getUserProfile = async (token: any, userId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/UserManagement/GetUserProfile?userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const deleteUser = async (token: any, username: any, userId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/UserManagement/DeleteUser?username=${username}&userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const getUpdateUserModel = async (token: any, userId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/UserManagement/GetUpdateUserModel?userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response.data
    } catch (error) {
        return error;
    }
}

export const updateUser = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/UserManagement/updateUser`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
    } catch (error) {
        return error;
    }
}

export const getUserRoles = async (token: any, userId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/UserManagement/getUserRoles?userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response.data
    } catch (error) {
        return error;
    }
}

export const assignRoleToUser = async (token: any, roleId: any, userId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/UserManagement/AssignRoleToUser?roleId=${roleId}&userId=${userId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const removeRoleFromUser = async (token: any, roleId: any, userId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/UserManagement/removeRoleFromUser?roleId=${roleId}&userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const changeUserPassword = async (token: any, newPassword: any, userId: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/UserManagement/changeUserPassword?newPassword=${newPassword}&userId=${userId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
    } catch (error) {
        return error;
    }
}

export const doorToDoorPolicy = async (token: any, userJobId: any, shiftHours: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Locations/CalculateDoorToDoorPolicy?userJobId=${userJobId}&shiftHours=${shiftHours}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return response.data;
    } catch (error) {
        console.log(error)
        return error;
    }
}

export const sendCustomPushNotification = async (token: any, title: any, desc: any, workers: any) => {
    try {
        const response = await axios.post(`${mobileApiUrl}/notifications/SendCustomPushNotifications?title=${title}&messageDetails=${desc}`, workers, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        return error;
    }
}

export const addGradingToWorker = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/workerManagement/AddGradingToWorker?attendance=${payload.attendance}&attitude=${payload.attitude}&site_feedback=${payload.siteFeedback}&workerId=${payload.workerId}`, {},{
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            })
        return response;
    } catch (error) {
        return error;    
    }
}

export const getAverageGradings = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/GetAverageGradings?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getWebForms = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/webForms/getWebForms`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;

    } catch (error) {
        console.log(error)
    }
}

export const getGradingsAssignments = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/getGradingAssignments?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const deleteGrading = async (token: any, gradingId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/WorkerManagement/deleteGrading?gradingId=${gradingId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const addNewWebForm = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/WebForms/AddNewWebForm`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const deleteWebForm = async (token: any, webFormId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/WebForms/deleteWebForm?webFormId=${webFormId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const editWebForm = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/WebForms/EditWebForm`, payload, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const cloneClients = async (token: any, previousCodeName: any, currentCodeName: any) => {
    try {
        const response = await axios.post(`${apiUrl}/Resourcing/CloneClientsFromResourceGrid?previousCodeName=${previousCodeName}&currentCodeName=${currentCodeName}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const searchDistanceMatrices = async (token: any, originPostCode: any, destinationPostCode: any, pagination = 1) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Locations/searchDistanceMatrices?originPostCode=${originPostCode}&destinationPostCode=${destinationPostCode}&pagination=${pagination}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const calculateDistanceMatrix = async (token: any, originPostCode: any, destinationPostCode: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Locations/calculateDistanceMatrix?originPostCode=${originPostCode}&destinationPostCode=${destinationPostCode}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const getWorkerJobTravelInfo = async (token: any, jobId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Locations/GetWorkerJobTravelInfo?jobId=${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response;

    } catch (error) {
        console.log(error)
    }
}

export const getWorkersAvailability = async (token: any, payload: any) => {
    try {
        const response = await axios.get(`${apiUrl}/Resourcing/getWorkersAvailability?from=${payload.startDate}&until=${payload.endDate}&type=${payload.type}&pagination=1`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const checkIfWorkerWithPTSExists = async (token: any, ptsNumber: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/CheckIfWorkerWithPTSExists?ptsNumber=${ptsNumber}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getWorkersPaginated = async (token: any, payload: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/FRIManagement/GetWorkersPaginated`, {
            params: {
              startWeek: payload.startWeek,
              endWeek: payload.endWeek,
              year: payload.year,
              query: payload.query,
              page: 0,
              itemsPerPage: 0,
            }, 
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            signal: payload.signal,
        });

        return response.data
    } catch (error) {
      console.error(error);
    }
};

export const getWorkersfrjobsPaginated = async (token: any, payload: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/FRIManagement/GetWorkerFRJobsPaginated`, {
            params: {
                userId: payload.userId,
                startWeek: payload.startWeek,
                endWeek: payload.endWeek,
                year: payload.year,
                page: 0,
                itemsPerPage: 0,
                companyId: payload.companyId?.id,
            }, 
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        return response.data
    } catch (error) {
      console.error(error);
    }
};

export const calculateWorkerFRI = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
          `${apiUrl}/api/FRICalculator/CalculateWorkerFRIRanged`,
          {},
          {
            params: {
              userId: payload.userId,
              startWeek: payload.startWeek,
              endWeek: payload.endWeek,
              year: payload.year,
            },
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
          }
        );

        return response.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            const errors =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.errors || "Unknown error";

            return { success: false, message, errors: errors };
        }

        return { success: false, message: "Network or unexpected error" };
    }
};

export const editAllWorkerDefaults = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/FRIManagement/EditWorkerWorkDefault/${payload.workerId}`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const editUserJobDefaults = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/FRIManagement/EditUserJobWorkDefault/${payload.userJobId}`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getWorkerDefaults = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/FRIManagement/GetWorkerWorkDefault/${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const overrideAllWorkerJobDefaults = async (token: any, userId: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/FRIManagement/OverrideAllWorkerJobDefaults/${userId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const resetUserJobDefault = async (token: any, userJobId: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/FRIManagement/ResetUserJobDefault/${userJobId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const generateExcel = async (token: any, userId: any, companyId: any, recipientEmail: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Excel/GenerateWorkerFRIReport/${userId}`,
            {},
            {
                params: {
                    userId: userId,
                    companyId: companyId,
                    recipientEmail: recipientEmail,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        // const { fileData, fileName, mimeType } = response.data;

        // const binaryString = atob(fileData);
        // const bytes = new Uint8Array(binaryString.length);
        // for (let i = 0; i < binaryString.length; i++) {
            // bytes[i] = binaryString.charCodeAt(i);
        // }
        // const blob = new Blob([bytes], { type: mimeType });

        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = fileName;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);

        return response;
    } catch (error: any) {
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
};

export const getClientsByWorkerId = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Collaborations/getClientsByWorkerId?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const calculateAllWorkerFRI = async (token: any) => {
    try {
        const response = await axios.post(
          `${apiUrl}/api/FRICalculator/calculateAllWorkerFRI`,
          {},
          {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
          }
        );
        console.log(response);
        return response;
    } catch (error) {
      console.error(error);
        throw error;
    }
};

export const updateWorkersTime = async (token: any, sheet: any) => {
    try {
        const formData = new FormData();
        formData.append('file', sheet);

        const response = await axios.post(`${apiUrl}/api/FriCalculator/updateWorkersTime`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        console.log(response)
        return response;
    } catch (error: any) {
         if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };

    }
}

export const changeNewUserPassword = async (token: any, newPassword: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/Profile/ChangeNewUserPassword?newPassword=${newPassword}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
    } catch (error) {
        return error;
    }
}

export const generateFRIReport = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Excel/GenerateWeeklyAdvisoryFRIReport`,
            {},
            {
                params: {
                    week: payload.week,
                    year: payload.year,
                    clientId: payload?.clientId?.id,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { fileData, fileName, mimeType } = response.data;

        const binary = atob(fileData);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    } catch (error) {
        console.error(error);
    }
};

export const generateWorkHoursReport = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/Excel/GenerateWorkHoursReport`,
            {},
            {
                params: {
                    week: payload.week,
                    year: payload.year,
                    companyId: payload?.clientId,
                    projectId: payload.projectId,
                    startDate: payload.startDate,
                    endDate: payload.endDate,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { fileData, fileName, mimeType } = response.data;

        const binary = atob(fileData);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getWeeklyAddedUsers = async (token: any, week: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/getWeeklyAddedUsers?week=${week}&year=${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addContactHistory = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/CallHistory`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const getAllContactHistory = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/CallHistory/all/${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const recalculateCommutingTime = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/Resourcing/RecalculateJobWorkersCommutingTime?jobId=${payload.jobId}&jobPostCode=${payload.jobPostCode}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const getProjectsByCompany = async (
    token: any,
    payload: any
) => {
    try {
        const response = await axios.get(
            `${apiUrl}/api/Collaborations/GetProjectsWithCountOfWorkersByCompanyId/${payload.clientId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                params: payload,
            }
        );

        return response?.data;
    } catch (error) {
        console.log(error);
    }
};

export const deleteCompany = async (token: any, companyId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Collaborations/DeleteCompany/${companyId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error: any) {
        if (error.response) {
            if (error.response.status === 403) {
                return { success: false, forbidden: true };
            }
        }
    }
}

export const deleteProject = async (token: any, projectId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Collaborations/DeleteProject/${projectId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error: any) {
        if (error.response) {
            if (error.response.status === 403) {
                return { success: false, forbidden: true };
            }
        }
    }
}

export const GetActiveProjects  = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Collaborations/GetActiveProjects `, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const GetDuplicateUsers  = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/UserManagement/GetDuplicateUsers `, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const CheckWorkersShiftCounts = async (token: any, users: any) => {
    try {
        const userIds = users.map((u: any) => u.id);

        const response = await axios.post(
            `${apiUrl}/api/UserManagement/CheckWorkersShiftCounts`,
            userIds,
            {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'ngrok-skip-browser-warning': '69420',
                  'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.log(error);
    }
};

export const mergeUserJobs = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/UserManagement/mergeUserJobs`,
            {
                duplicateUserId: payload.duplicateUserId,
                originalUserId: payload.originalUserId,
                deleteOldData: true,
            },
            {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'ngrok-skip-browser-warning': '69420',
                  'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
};

export const addIdentificationType = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/WorkerIdentification/AddWorkerIdentificationType`,
            payload,
            {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'ngrok-skip-browser-warning': '69420',
                  'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
};

export const getAllWorkerIdentificationTypes = async (token: any) => {
    try {
        const response = await axios.get(
            `${apiUrl}/api/WorkerIdentification/GetAllWorkerIdentificationTypes`,
            {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'ngrok-skip-browser-warning': '69420',
                  'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error: any) {
        return { success: false, message: "Network or unexpected error" };
    }
};

export const getCalendarRequests = async (token: any, payload: any) => {
    try {
        const response = await axios.get(
            `${apiUrl}/api/CalendarManager/GetCalendarRequests`,
            {
                params: {
                  pts: payload?.pts,
                  fromDate: payload?.fromDate,
                  toDate: payload?.toDate,
                },
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
            }
        );
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const cancelShift = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/ShiftData/CancelShift`,
            payload,
            {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'ngrok-skip-browser-warning': '69420',
                  'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            const message =
              typeof error.response.data === "string"
                ? error.response.data
                : error.response.data.message || "Unknown error";

            return { success: false, message };
        }

        return { success: false, message: "Network or unexpected error" };
    }
};

export const getShiftData = async (token: any, payload?: any) => {
  try {
    const response = await axios.get(`${apiUrl}/api/ShiftData/GetShiftData`, {
      params: {
        noticePeriod:
          payload?.noticePeriod !== null && payload?.noticePeriod !== undefined
            ? Number(payload.noticePeriod)
            : undefined,
        name: payload?.name,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getRailYear = async (token: any, year: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ResourcingData/GetRailCalendars/${year}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error;
    }
}


export const reCalculateAllWorkerHours = async (token: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/FRICalculator/ReCalculateAllWorkerHours`, {},
            {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json"
                },
            }
        );
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const addWorkerRole = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Worker/addWorkerRole`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response
    } catch (error) {
        console.log(error)
    }
}

export const removeWorkerRole = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/Worker/removeWorkerRole/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const editCancelledShiftData = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/ShiftData/EditCancelledShiftData`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const getSafetyFroms = async (token: any, userId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Safety/GetSafetyFroms/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getPasswordRecoveries = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Recovery/GetPasswordRecoveries`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        return error
    }
}

export const generateNewlyAddedUsers = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/WorkerManagement/GenerateNewlyAddedUsers`,
            {},
            {
                params: payload,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { fileData, fileName, mimeType } = response.data;

        const binary = atob(fileData);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getShiftsByLocation = async (token: any, payload: any) => {
  try {
    const response = await axios.get(`${apiUrl}/Resourcing/GetShiftsByLocation`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        params: {
          postCode: payload.postCode,
          startDate: payload.startDate,
          endDate: payload.endDate
        }
      }
    );

    return response.data;

    console.log(response.data);
  } catch (error) {
    console.error("Error fetching shifts:", error);
  }
};

export const getEditWorkerIds = async (token: any, workerId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/GetEditWorkerIds?workerId=${workerId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const editWorkerId = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/workerManagement/EditWorkerId`, payload, {
            params: {
                workerId: payload.workerId,
            },
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const addWorkerId = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/workerManagement/AddWorkerId`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.error("Error:", error);
    }
};

export const deleteWorkerId = async (token: any, payload: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/workerManagement/DeleteWorkerId`, {
            params: {
                workerId: payload.workerId,
                workerIdentificationId: payload.id
            },
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.error("Error:", error);
    }
};

export const deleteWorkerIdentification = async (token: any, id: any) => {
    try {
        const response = await axios.delete(
            `${apiUrl}/api/WorkerIdentification/DeleteWorkerIdentificationType/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}

export const updateWorkerIdentificationType = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/WorkerIdentification/UpdateWorkerIdentificationType/${payload.id}`, payload, {
            params: {
                workerId: payload.workerId,
            },
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }})
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getOnboardingFormsType = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/OnBoardingForm/GetOnBoardingFormTypes`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const addOnboardingFormType = async (token: any, ticketName: any, purpose: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/OnBoardingForm/AddOnBoardingFormType?ticketName=${ticketName}&purpose=${purpose}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const editOnboardingFormType = async (token: any, ticketId: any, newTicketName: any, purpose: any) => {
    try {
        const response = await axios.patch(
            `${apiUrl}/api/OnBoardingForm/EditOnBoardingFormType?ticketId=${ticketId}&newTicketName=${newTicketName}&purpose=${purpose}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const assignOnBoardingFormToUser = async (token: any, payload: any) => {
    try {
        const formData = new FormData();
        formData.append('userId', payload.userId);
        formData.append('onBoardingFormTypeId', payload.onBoardingFormTypeId);
        formData.append('expDate', payload.expDate);
        formData.append('onBoardingFormStatus', payload.onBoardingFormStatus);

        if (payload.onBoardingFormDocuments && payload.onBoardingFormDocuments.length) {
            for (let i = 0; i < payload.onBoardingFormDocuments.length; i++) {
                formData.append('onBoardingFormDocuments', payload.onBoardingFormDocuments[i]);
            }
        }

        const response = await axios.post(`${apiUrl}/api/OnBoardingForm/AssignOnBoardingFormToUser`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const getUserOnBoardingDocument = async (token: any, userTicketId: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/OnBoardingForm/GetUserOnBoardingDocuments?userTicketId=${userTicketId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response.data;
        
    } catch (error) {
        console.log(error)
    }
}

export const addOnBoardingFormDocuments = async (token: any, payload: any) => {
    try {
        const formData = new FormData();
        formData.append('userTicketId', payload.userTicketId);
        if (payload.documents && payload.documents.length) {
            for (let i = 0; i < payload.documents.length; i++) {
                formData.append('documents', payload.documents[i]);
            }
        }

        const response = await axios.post(`${apiUrl}/api/OnBoardingForm/AddOnBoardingFormDocuments`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const DeleteOnBoardingDocument = async (token: any, ticketDocumentId: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/OnBoardingForm/DeleteOnBoardingDocument?documentId=${ticketDocumentId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const removeOnBoardingFormTypeFromUser = async (token: any, id: any) => {
    try {
        const response = await axios.delete(`${apiUrl}/api/OnBoardingForm/RemoveOnBoardingFormTypeFromUser?userTicketId=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response
    } catch (error) {
        console.log(error)
    }
}

export const editUserOnBoardingForm = async (token: any, payload: any) => {
    try {
        const response = await axios.patch(`${apiUrl}/api/OnBoardingForm/EditUserOnBoardingForm`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });

        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const getOnlyResourcingWorkers = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/GetOnlyResourcingWorkers`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response.data;
        
    } catch (error) {
        console.log(error)
    }
}

export const GenerateNewlyAddedUsersV2 = async (token: any, payload: any) => {
    try {
        const response = await axios.post(
            `${apiUrl}/api/WorkerManagement/GenerateNewlyAddedUsersV2`,
            {},
            {
                params: payload,
                headers: {
                    Authorization: `Bearer ${token}`,
    
                    "Content-Type": "application/json",
                },
            }
        );

        const { fileData, fileName, mimeType } = response.data;

        const binary = atob(fileData);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = payload.name + '_' + 'User_Creation_Report' + '_' + format(payload.startDate, 'dd.MM.yyyy') + '_To_' + format(payload.endDate, 'dd.MM.yyyy') + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getWorkerProfileData = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Profile/ViewTokenProfile/${token}`);
        return response.data;
        
    } catch (error: any) {
        console.log(error)
        return {
            success: false,
            message: error.response?.data || 'Something went wrong'
        };
    }
}

export const submitUpdatedProfileData = async (token: any, payload: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/Profile/SubmitTokenUpdate/${token}`, payload);
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const getUpdateRequests = async (token: any, status: number | null) => {
    try {
        const response = await axios.get(`${apiUrl}/api/ProfileUpdate/GetUpdateRequests?status=${status}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const approveUpdate = async (token: any, requestId: any) => {
    try {
        const response = await axios.post(`${apiUrl}/api/ProfileUpdate/ApproveUpdate/${requestId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const rejectUpdate = async (token: any, requestId: any, reason: string) => {
    try {
        const response = await axios.post(`${apiUrl}/api/ProfileUpdate/RejectUpdate/${requestId}?reason=${encodeURIComponent(reason)}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const sendEmails = async (token: any, file: any) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post(`${apiUrl}/api/ProfileUpdate/SendUpdateEmails`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const submitTokenDeletion = async (token: any, reason: string) => {
    console.log(reason);
    try {
        const response = await axios.post(`${apiUrl}/api/Profile/SubmitTokenDeletion/${token}?reason=${encodeURIComponent(reason)}`, {}
        );
        return response;
        
    } catch (error) {
        console.log(error)
    }
}

export const verifyTokenDeletion = async (token: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/Profile/VerifyTokenDeletion/${token}`);
        return response.data;
        
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data.message || 'Something went wrong'
        };
    }
}

export const checkIfWorkerWithEmailExists = async (token: any, email: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/CheckIfWorkerWithEmailExists?email=${email}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getUsersWithSamePhoneNr = async (token: any, phoneNumber: any) => {
    try {
        const response = await axios.get(`${apiUrl}/api/WorkerManagement/GetUsersWithSamePhoneNr?phoneNumber=${encodeURIComponent(phoneNumber)}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    } catch (error) {
        console.log(error)
    }
}
